import { render } from "./seats.vue?vue&type=template&id=18776627"
import script from "./seats.vue?vue&type=script&lang=js"
export * from "./seats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__